import { useState, useMemo, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl'
import _get from 'lodash/get';
import Title from '@/shared/ui/Title';
import RadioGroup from "@/shared/ui/RadioGroup";
import {
  PAYOUTS_TYPE,
} from '~/shared/Payouts';
import PayoutsPoolTable from "./PayoutsPoolTable";
import PayoutsOSTable from "./PayoutsOSTable";

type PayoutsTableProps = {
  className?: string;
}

const PayoutsTable = (props: PayoutsTableProps) => {
  const { className } = props;
  const intl = useIntl();
  const [ payoutsType, setPayoutsType ] = useState(PAYOUTS_TYPE.POOL);
  const csvRef = useRef();

  const radioItems = [
    { value: PAYOUTS_TYPE.POOL, label: intl.formatMessage({id: 'payouts.pool'})},
    { value: PAYOUTS_TYPE.OS, label: intl.formatMessage({id: 'payouts.os'})},
  ];

  const handleChange = (e: any) => {
    const value = e.target.value || PAYOUTS_TYPE.POOL;
    setPayoutsType(value);
  };

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-6">
        <Title order={3}>
          <FormattedMessage id="payouts.history"/>
        </Title>

        {/* @ts-ignore here will be injected via portal CSV button */}
        <div ref={csvRef}/>
      </div>

      <RadioGroup
        className="mb-2"
        defaultValue={payoutsType}
        onChange={handleChange}
        name="type"
        items={radioItems}
        labelClassName=''
      />

      {{
        [PAYOUTS_TYPE.POOL]: <PayoutsPoolTable csvRef={csvRef}/>,
        [PAYOUTS_TYPE.OS]: <PayoutsOSTable csvRef={csvRef}/>,
      }[payoutsType]}

    </div>
  );
}

export default PayoutsTable;
